import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import { setActiveGym } from "../../redux/reducers/authSlice";

// Multi-gym owner ke liye gym switcher (sidebar me, profile ke neeche).
// Sirf tab dikhta hai jab owner ke 1 se zyada gyms hain. Switch karne pe active
// gym redux me set hota hai (saare `user.gym_id` consumers naya gym use karte)
// aur data re-fetch ke liye page reload ho jaata hai.
const GymSwitcher = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const gyms = Array.isArray(user?.gyms) ? user.gyms : [];

  if (gyms.length <= 1) return null;

  const handleChange = (e) => {
    const value = e.target.value;
    const gym = gyms.find((g) => g.value === value);
    if (gym && value !== user?.gym_id) {
      dispatch(setActiveGym(gym));
      // active gym badla → saara data naye gym ke hisaab se laana
      setTimeout(() => window.location.reload(), 60);
    }
  };

  return (
    <div className="v2-gym-switcher">
      <span className="v2-gym-switcher__label">Active Gym</span>
      <select
        className="v2-gym-switcher__select"
        value={user?.gym_id || ""}
        onChange={handleChange}
        title="Switch gym"
      >
        {gyms.map((gym) => (
          <option key={gym.value} value={gym.value}>
            {gym.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default GymSwitcher;
